import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import CloseButton from "./CloseButton";

const Toast = ({ notice }) => {
  const [show, setShow] = useState(true);

  if (!show) {
    return null;
  }

  return (
    <div className="flex justify-end">
      <div
        className={`max-w-xs bg-tggreen text-sm text-tgnavy rounded-md shadow-lg dark:bg-gray-900`}
        role="alert"
      >
        <div className="flex p-4 items-center">
          <span className="flex-1">{notice}</span>
          <span className="ml-3">
            <CloseButton onClick={(e) => setShow(false)} />
          </span>
        </div>
      </div>
    </div>
  );
};

Toast.propTypes = {
  notice: PropTypes.string.isRequired,
};

export default Toast;



// WEBPACK FOOTER //
// ./app/javascript/bundles/ui/Toast/index.jsx